module.exports = __webpack_public_path__ + "img/gold-sequins-background.5ee407a0.png";